<template>
  <q-page fluid style="min-height: 0px; top: 30vh">
    <div
      :style="`height: 100vh; width: 100vw; position: fixed; top: 0; left: 0`"
    >
      <googleMaps
        v-if="!offlineMode"
        :center="{ lng: 172.64715, lat: -43.5781 }"
        :zoom="7"
        :clustorMarkers="markers"
        mapType="terrain"
        :options="{
          zoomControl: false,
          fullscreenControl: false,
          streetViewControl: false,
          mapTypeControl: true,
        }"
        style="height: 100%; width: 100%; position: relative; z-index: 1"
        @updatePos="updateCenterPOS"
        @clustorMapMarkerClicked="
          (val) => $router.push(`/mobile-view/survey-mp-report/${val.id}`)
        "
        ref="gmap"
      >
      </googleMaps>
      <leaflet-maps
        v-if="offlineMode"
        :center="{ lng: 172.64715, lat: -43.5781 }"
        :zoom="7"
        :clustorMarkers="markers"
        mapType="terrain"
        :options="{
          zoomControl: false,
          fullscreenControl: false,
          streetViewControl: false,
          mapTypeControl: true,
        }"
        style="height: 100%; width: 100%; position: relative; z-index: 1"
        @updatePos="updateCenterPOS"
        @clustorMapMarkerClicked="
          (val) => $router.push(`/mobile-view/survey-mp-report/${val.id}`)
        "
        ref="gmap"
      >
      </leaflet-maps>
    </div>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import googleMaps from "@/components/googleMaps/googleMaps.vue";
import LeafletMaps from "@/components/leaflet/leafletMaps.vue";

export default {
  components: { googleMaps, LeafletMaps },
  computed: {
    ...mapGetters([
      "currentUser",
      "pastSurveys",
      "pastSurveysLoading",
      "offlineMode",
    ]),
  },
  props: {
    source: String,
  },
  data: () => ({
    markers: [],
    coords: {
      lng: 172.64715,
      lat: -43.5781,
    },
  }),
  beforeCreate() {
    this.$store.dispatch("loadPastSurveys").then(() => {
      this.init();
    });
  },
  mounted() {},
  watch: {
    pastSurveys: function () {
      this.init();
    },
  },
  methods: {
    init() {
      this.markers = [];
      this.pastSurveys.forEach((survey) => {
        this.markers.push({
          lat: survey.startingPoint_lat,
          lng: survey.startingPoint_lng,
          data: survey,
        });
      });
    },
    setPosition(position) {
      this.coords.lng = position.lng;
      this.coords.lat = position.lat;
    },
    updateCenterPOS(position) {
      this.$refs.gmap.panToLocation(position);
    },
    runError(error) {
      this.$q.notify({
        position: "top-right",
        type: "error",
        message: error.message,
      });
    },
    dotClicked(point) {
      this.geoPointRecording = point;
      if (this.range) {
        this.$refs.chart.dataPointSelection(point);
      }
    },
  },
};
</script>

<style>
#reportSlider > .q-slider__track-container {
  background-color: rgba(0, 0, 0, 0) !important;
}
</style>
